import o from "./_copyObject.js";
import e from "./keys.js";
function m(r, t) {
  return r && o(t, e(t), r);
}
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseAssign.js
// module id = 1421
// module chunks = 41